"use client";

import dynamic from "next/dynamic";
import Image from "next/image";
import Link from "next/link";

import { LocaleEnum } from "@/types/utils/locale";
import { convertToKebabCase } from "@/utils/common/convertHelper/convertToKebabCase";

import ControlNavFooter from "./ControlNavFooter";

const NotFoundComponent = dynamic(
  () => import("@/components/global/NotFoundComponent/NotFoundComponent"),
  { ssr: false, loading: () => <div className="h-[465.15px]" /> },
);

const NotFoundGroupComponent = ({ lang }: { lang: string }) => {
  return (
    <>
      <div
        id={convertToKebabCase("NavBar")}
        className="nav-custom h-[48px] border-b border-stroke-light bg-background-baigeBG lg:border-0"
      >
        <div className="text-mainMainColor mx-auto flex h-full max-w-[1200px] items-center justify-center px-[5px] py-0 md:justify-start md:px-[8px] lg:px-[16px] xl:px-0">
          <Link
            id={convertToKebabCase("GoHome")}
            href={`/${lang}`}
            className="flex shrink-0 items-center"
            title="Go Gother Home"
          >
            <button
              id={convertToKebabCase("HomeButton")}
              title="home"
              type="button"
              // onClick={handleClickLogo}
            >
              <Image
                src="https://d31jk6ljx7wihh.cloudfront.net/images/logo.svg"
                alt="Gother"
                priority
                width={95}
                height={30}
              />
            </button>
          </Link>
        </div>
      </div>
      <ControlNavFooter />
      <NotFoundComponent
        notFoundText={
          lang === LocaleEnum.TH
            ? "ขออภัย เราไม่พบหน้านี้"
            : "Sorry, we couldn't find this page"
        }
        backHomeText={
          lang === LocaleEnum.TH ? "กลับไปหน้าหลัก" : "Back to Home"
        }
      />
    </>
  );
};

export default NotFoundGroupComponent;
